import React from 'react';
import { useAuth } from '../contexts';
import NotFound from '../pages/NotFound';
import EmailVerificationBanner from './EmailVerificationBanner';

export default function AdminRoute({ children }) {
  const { isAuthenticated, user } = useAuth();
  const isAdmin = user?.is_staff || user?.is_superuser;

  if (!isAuthenticated || !isAdmin) {
    return <NotFound />;
  }

  return (
    <>
      <EmailVerificationBanner user={user} />
      {children}
    </>
  );
}
